import React from 'react'

const FundingCard = ({ title, description, items, icon }) => {
    return (
      <>
  
        
          <div className="card bg-white h-100 p-4 card-hover-pop mx-2" style={{borderRadius: '14px' }}>
            <div className="d-flex flex-column h-100">
              {/* Centered section */}
              <div className="text-center mb-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-circle text-primary mx-auto"
                  style={{ 
                    width: '48px', 
                    height: '48px', 
                    backgroundColor: '#F0F6FE', 
                    display: 'inline-flex', 
                    justifyContent: 'center', 
                    alignItems: 'center'
                  }}
                >
                  {icon}
                </div>
              </div>
  
              <div className="text-center">
                <h3 className=" mb-3" style={{color: '#000000', fontSize: '1.25rem', fontWeight: '500' }}>{title}</h3>
                <p className="text-muted mb-4" style={{ fontSize: '.9rem', fontWeight: 400 }}>{description}</p>
              </div>
  
              {/* List stays left-aligned */}
              <ul className="list-unstyled">
                {items.map((item, index) => (
                  <li key={index} className="d-flex align-items-start mb-2 text-muted">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-primary mt-1 me-2 flex-shrink-0 px-1"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span className="text-muted ms-2 d-flex">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          
        </div>
      </>
    );
  };
  
  export default function UplyftInfoLanding() {
    const iconStyle = { width: '24px', height: '24px' };
  
    const data = [
      {
        title: 'Flexible Funding',
        description: 'Access working capital tailored to your business needs',
        // icon: <svg style={iconStyle} fill="currentColor" viewBox="0 0 24 24"><path d="M12 1L3 5v6c0 5.25 3.75 10.75 9 12 5.25-1.25 9-6.75 9-12V5l-9-4z" /></svg>,
        icon:  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-dollar-sign w-6 h-6" data-lov-id="src/components/mca/NewMCAFundingTiers.tsx:62:10" data-lov-name="DollarSign" data-component-path="src/components/mca/NewMCAFundingTiers.tsx" data-component-line="62" data-component-file="NewMCAFundingTiers.tsx" data-component-name="DollarSign" data-component-content="%7B%22className%22%3A%22w-6%20h-6%22%7D"><line x1="12" x2="12" y1="2" y2="22"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>,
        items: [
          'Funding up to $5,000,000',
          'No fixed monthly payments',
          'Use funds for any business purpose'
        ]
      },
      {
        title: 'Quick Process',
        description: 'Get approved and funded faster than traditional loans',
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-clock w-6 h-6" data-lov-id="src/components/mca/NewMCAFundingTiers.tsx:72:10" data-lov-name="Clock" data-component-path="src/components/mca/NewMCAFundingTiers.tsx" data-component-line="72" data-component-file="NewMCAFundingTiers.tsx" data-component-name="Clock" data-component-content="%7B%22className%22%3A%22w-6%20h-6%22%7D"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>,
        items: [
          '24-48 hour approvals',
          'Simple application process',
          'Minimal documentation needed',
          

        ]
      },
      {
        title: 'Easy Qualification',
        description: 'Flexible requirements make it easier to qualify',
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-file-text w-6 h-6" data-lov-id="src/components/mca/NewMCAFundingTiers.tsx:82:10" data-lov-name="FileText" data-component-path="src/components/mca/NewMCAFundingTiers.tsx" data-component-line="82" data-component-file="NewMCAFundingTiers.tsx" data-component-name="FileText" data-component-content="%7B%22className%22%3A%22w-6%20h-6%22%7D"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>,
        items: [
          'No collateral required',
          'Bad credit accepted',
          'Based on business performance'
        ]
      },
      {
        title: 'Flexible Repayment',
        description: 'Pay based on your daily credit card sales',
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-trending-up w-6 h-6" data-lov-id="src/components/mca/NewMCAFundingTiers.tsx:92:10" data-lov-name="TrendingUp" data-component-path="src/components/mca/NewMCAFundingTiers.tsx" data-component-line="92" data-component-file="NewMCAFundingTiers.tsx" data-component-name="TrendingUp" data-component-content="%7B%22className%22%3A%22w-6%20h-6%22%7D"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline><polyline points="16 7 22 7 22 13"></polyline></svg>,
        items: [
          'Revenue-based payments',
          'Adjust with your cash flow',
          'No hidden fees'
        ]
      }
    ];
  
    return (
      <div>
        <div className="row mt-4rem">
          <div className="col-12 col-lg-12 text-center">
              
            <h1 className='h1-title-dark'>
              Simple & Flexible Funding Solutions
            </h1>
            <p className="subheader-dark mt-4">
              Get the working capital you need with our streamlined merchant cash advance program. Quick approvals, flexible terms, and funding up to $5,000,000.
            </p>
            <div className='row w-100 d-flex justify-content-center'>
              <div
                className="d-flex justify-content-center align-items-center px-2 py-2"
                style={{
                  color: '#007bff',
                  fontSize: '0.7rem',
                  backgroundColor: '#F0F6FE', // white with 40% opacity
                  borderRadius: '9999px',       // fully rounded (pill shape)
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="me-2"
                >
                  <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                  <path d="m9 11 3 3L22 4"></path>
                </svg>
                <p className="mb-0 text-sm px-2">No Hard Credit Check Required</p>
              </div>

            </div>
          </div>
        </div>
        <div className="row mt-4rem p-4">
          {data.map((tier, idx) => (
            <div key={idx} className="col-md-6 col-lg-3 mb-4 p-0">
              <FundingCard {...tier} />
            </div>
          ))}
        </div>
      </div>
    );
  }
  